import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class LeirasTetelAsszociaciosListItemDto extends IdentifiableDto {
	constructor() {
		super();
        /** @type {string} */
		this.betujel = null;
        /** @type {string} */
        this.szoveg = null;
        /** @type {string} */
        this.magyarazat = null;
		/** @type {string} */
        // this.kerdesAsszoc = null;
	}

	/**
	 * @Parameter {string} betujel
     * @Parameter {string} szoveg
     * @Parameter {string} magyarazat
	 * @Parameter {number} kerdesAsszoc
	 */
	setup(props) {
		super.setup(props);
		this.betujel = props.betujel;
        this.szoveg = props.szoveg;
        this.magyarazat = props.magyarazat;
		//this.kerdesAsszoc = props.kerdesAsszoc;
		return this;
	}
}

export default LeirasTetelAsszociaciosListItemDto;
